/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ChevronRight/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ChevronRight({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ChevronRight",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 8,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ChevronRight.Svg"
  data-view-path={viewPath}
 viewBox="0 0 8 12"
 style={{'--as-1-iDpQF': alignSelf,'--mt-2-iDpQF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-iDpQF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-iDpQF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-iDpQF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-iDpQF': opacity,'--w-10-iDpQF': typeof width === 'number' ? `${width}px` : width,'--h-11-iDpQF': typeof height === 'number' ? `${height}px` : height,'--f-12-iDpQF': fill,'--a-7-iDpQF': isAnimated ? animation : "none",'--sd-8-iDpQF': isAnimated ? strokeDashoffset : 0,'--sd-9-iDpQF': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ChevronRight.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.911.251a.857.857 0 011.212 0l4.84 4.84a1.286 1.286 0 010 1.818l-4.84 4.84a.857.857 0 01-1.212-1.212L5.448 6 .911 1.463a.857.857 0 010-1.212z"
 style={{'--f-12-iDpQF': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}